export interface PricingTier {
  key: string;
  name: string;
  tagline: string;
  price: string;
  priceSuffix?: string;
  priceNote?: string;
  ctaLabel: string;
  ctaHref: string;
  highlighted?: boolean;
  features: string[];
}

export const pricingTiers: PricingTier[] = [
  {
    key: "baslangic",
    name: "Başlangıç",
    tagline: "Tek kişilik veya yeni açılan atölye için başlangıç paketi.",
    price: "749 ₺",
    priceSuffix: "/ ay",
    priceNote: "+ KDV",
    ctaLabel: "Ücretsiz Deneyin",
    ctaHref: "/register",
    features: [
      "1 kullanıcı",
      "1 şube",
      "500 müşteri kaydı",
      "750 araç kaydı",
      "Aylık 150 servis kaydı",
      "250 parça ve tedarik kaydı",
      "Servis geçmişi ve plaka takibi",
      "Temel mali özet",
      "Mobil ve tablet erişim",
      "E-posta destek",
    ],
  },
  {
    key: "profesyonel",
    name: "Profesyonel",
    tagline: "Büyüyen atölyeler için en çok tercih edilen paket.",
    price: "1.799 ₺",
    priceSuffix: "/ ay",
    priceNote: "+ KDV",
    ctaLabel: "Ücretsiz Deneyin",
    ctaHref: "/register",
    highlighted: true,
    features: [
      "5 kullanıcı",
      "2 şube",
      "5.000 müşteri kaydı",
      "10.000 araç kaydı",
      "Aylık 1.500 servis kaydı",
      "2.500 parça ve tedarik kaydı",
      "Çalışan rolleri ve yetkileri",
      "Tedarikçi cari hesap takibi",
      "Detaylı mali rapor",
      "Periyodik bakım hatırlatma",
      "CSV dışa aktarım",
      "Öncelikli e-posta destek",
    ],
  },
  {
    key: "kurumsal",
    name: "Kurumsal",
    tagline: "Çok şubeli ve büyük operasyonlar için ölçek paketi.",
    price: "3.999 ₺",
    priceSuffix: "/ ay",
    priceNote: "+ KDV",
    ctaLabel: "Ücretsiz Deneyin",
    ctaHref: "/register",
    features: [
      "15 kullanıcı",
      "10 şube",
      "25.000 müşteri kaydı",
      "50.000 araç kaydı",
      "Aylık 7.500 servis kaydı",
      "15.000 parça ve tedarik kaydı",
      "Rol bazlı ayrıntılı yetkilendirme",
      "Denetim (audit) logu",
      "API erişimi",
      "Otomatik günlük yedekleme",
      "Öncelikli destek ve eğitim",
      "SLA garantisi",
    ],
  },
  {
    key: "elit",
    name: "Elit",
    tagline: "Franchise ve zincir işletmeler için özel çözüm.",
    price: "Teklife Bağlı",
    priceNote: "Özel fiyatlandırma",
    ctaLabel: "İletişime Geçin",
    ctaHref: "/contact",
    features: [
      "Sınırsız kullanıcı",
      "Sınırsız şube",
      "Sınırsız müşteri ve araç",
      "Sınırsız servis kaydı",
      "Sınırsız parça ve tedarik",
      "Kurumsal paketin tüm özellikleri",
      "Özel entegrasyonlar (muhasebe, ERP)",
      "On-premise veya özel bulut",
      "Size özel hesap yöneticisi",
      "Genişletilmiş SLA",
      "Özel eğitim programı",
    ],
  },
];
